<template >
  <v-footer class="foot mobile-hide" dark height="auto" color="black">
    <v-layout row wrap style="100%;">
      <v-flex xs4 text-xs-left>
        <v-icon 
          @click="social('email')"
          style="padding-bottom:3px;"
          :size="20"
          :color="'#FFFFFF'">
          fas fa-envelope
        </v-icon>
        <div style="color: white;">
          Email Us
        </div>
      </v-flex>

      <v-flex xs4 text-xs-center>
        <img style="height: 45px;" class="logo-shift" src="@/assets/info.png">
      </v-flex>

      <v-flex xs4 text-xs-right>
        <div>
          <v-icon 
            @click="social('facebook')"
            class="pr-2 pl-2"
            style="padding-bottom:3px;"
            :size="17"
            :color="'#FFFFFF'">
            fab fa-facebook-f
          </v-icon>
          <v-icon
            @click="social('instagram')"
            class="pr-2 pl-2"
            :size="22"
            :color="'#FFFFFF'">
            fab fa-instagram
          </v-icon>
          <v-icon
            @click="social('twitter')"
            class="pl-2 pr-2"
            :size="22"
            :color="'#FFFFFF'">
            fab fa-twitter
          </v-icon>
        </div>
        <div style="color: white;" class="pr-2">
          Follow Us
        </div>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  name: 'footerBar',
  props: {
  },
  computed: {
  },
  methods: {
    social: function(type) {
      if (type == 'email'){
        window.open('mailto:marketing@hydrafacial.com'); 
      }
      else if (type == 'facebook'){
        window.open('https://www.facebook.com/hydrafacial', '_blank'); 
      }
      else if (type == 'instagram'){
        window.open('https://www.instagram.com/hydrafacial', '_blank'); 
      }
      else if (type == 'twitter'){
        window.open('https://twitter.com/hydrafacial', '_blank'); 
      }
    },
  }
};
</script>

<style scoped>
.foot{
  margin: 0px !important;
  padding-top: 8px !important;
  padding-left: 8px !important;
  padding-right: 3px !important;
  width: 100% !important;
}
.logo-shift{
  padding: 0px;
  margin: 0px;
}

@media (max-width: 600px) {
  .mobile-hide{
    display: none !important;
  }
}


</style>